import { createSlice } from "@reduxjs/toolkit";

export const ticketInboxSlice = createSlice({
  name: "ticketInbox",
  initialState: {
    //Spam
    getSpamResult: false,
    getSpamLoading: false,
    getSpamError: false,
    addSpamResult: false,
    addSpamLoading: false,
    deleteSpamResult: false,
    //Trash
    getTrashResult: false,
    getTrashLoading: false,
    getTrashError: false,
    addTrashResult: false,
    addTrashLoading: false,
    deleteTrashResult: false,
    //Overdue
    getOverdueResult: false,
    getOverdueLoading: false,
    getOverdueError: false,
    addOverdueResult: false,
    addOverdueLoading: false,
    deleteOverdueResult: false,
    //Unassigned
    getUnassignedResult: false,
    getUnassignedLoading: false,
    getUnassignedError: false,
    addUnassignedResult: false,
    addUnassignedLoading: false,
    deleteUnassignedResult: false,
    //my ticket
    getMyTicketResult: false,
    getMyTicketLoading: false,
    getMyTicketError: false,
    addMyTicketResult: false,
    addMyTicketLoading: false,
    deleteMyTicketResult: false,
    // ticket inbox
    getTicketInboxResult: false,
    getTicketInboxLoading: false,
    getTicketInboxError: false,
    addTicketInboxResult: false,
    addTicketInboxLoading: false,
    deleteTicketInboxResult: false,
    // ticket Search
    getTicketSearchResult: false,
    getTicketSearchLoading: false,
    getTicketSearchError: false,
    addTicketSearchResult: false,
    addTicketSearchLoading: false,
    deleteTicketSearchResult: false,
  },
  reducers: {
    ticketInboxReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        //Get Spam
        case "GET_SPAM":
          return {
            ...state,
            getSpamResult: payload.data,
            getSpamLoading: payload.loading,
            getSpamError: payload.error,
          };
        case "ADD_SPAM":
          return {
            ...state,
            addSpamResult: payload.data,
            addSpamLoading: payload.loading,
          };
        case "DELETE_SPAM":
          return {
            ...state,
            deleteSpamResult: payload.data,
          };

        //Get Trash
        case "GET_TRASH":
          return {
            ...state,
            getTrashResult: payload.data,
            getTrashLoading: payload.loading,
            getTrashError: payload.error,
          };
        case "ADD_TRASH":
          return {
            ...state,
            addTrashResult: payload.data,
            addTrashLoading: payload.loading,
          };
        case "DELETE_TRASH":
          return {
            ...state,
            deleteTrashResult: payload.data,
          };

        //Get Overdue
        case "GET_OVERDUE":
          return {
            ...state,
            getOverdueResult: payload.data,
            getOverdueLoading: payload.loading,
            getOverdueError: payload.error,
          };
        case "ADD_OVERDUE":
          return {
            ...state,
            addOverdueResult: payload.data,
            addOverdueLoading: payload.loading,
          };
        case "DELETE_OVERDUE":
          return {
            ...state,
            deleteOverdueResult: payload.data,
          };

        //Get Unassigned
        case "GET_UNASSIGNED":
          return {
            ...state,
            getUnassignedResult: payload.data,
            getUnassignedLoading: payload.loading,
            getUnassignedError: payload.error,
          };
        case "ADD_UNASSIGNED":
          return {
            ...state,
            addUnassignedResult: payload.data,
            addUnassignedLoading: payload.loading,
          };
        case "DELETE_UNASSIGNED":
          return {
            ...state,
            deleteUnassignedResult: payload.data,
          };

        //Get My Ticket
        case "GET_MYTICKET":
          return {
            ...state,
            getMyTicketResult: payload.data,
            getMyTicketLoading: payload.loading,
            getMyTicketError: payload.error,
          };
        case "ADD_MYTICKET":
          return {
            ...state,
            addMyTicketResult: payload.data,
            addMyTicketLoading: payload.loading,
          };
        case "DELETE_MYTICKET":
          return {
            ...state,
            deleteMyTicketResult: payload.data,
          };

        //Get Ticket Inbox
        case "GET_TICKETINBOX":
          return {
            ...state,
            getTicketInboxResult: payload.data,
            getTicketInboxLoading: payload.loading,
            getTicketInboxError: payload.error,
          };
        case "ADD_TICKETINBOX":
          return {
            ...state,
            addTicketInboxResult: payload.data,
            addTicketInboxLoading: payload.loading,
          };
        case "DELETE_TICKETINBOX":
          return {
            ...state,
            deleteTicketInboxResult: payload.data,
          };

        //Get Ticket Search
        case "GET_TICKETSEARCH":
          return {
            ...state,
            getTicketSearchResult: payload.data,
            getTicketSearchLoading: payload.loading,
            getTicketSearchError: payload.error,
          };
        case "ADD_TICKETSEARCH":
          return {
            ...state,
            addTicketSearchResult: payload.data,
            addTicketSearchLoading: payload.loading,
          };
        case "DELETE_TICKETSEARCH":
          return {
            ...state,
            deleteTicketSearchResult: payload.data,
          };

        default:
          return state;
      }
    },
  },
});

export const { ticketInboxReducers } = ticketInboxSlice.actions;

export default ticketInboxSlice.reducer;
